<template>
    <div class='flex h-full ds-tip-prib-view' style='overflow: auto'>
        <div class='flex h-full tep-tree__container'>
            <ai-tree-list-edit
                ref='treeRef'
                :meta="treeMeta"
                :to-remove-toolbar-items-names="removeTreeToolbarBtns"
                @cell-click='onTreeCellClick'
                @insert-save="insertSave"
                @toolbar-button-click="onToolbarClickTree"
                @user-data-changed='onUserDataChanged'
                @changesSavedSuccessfully="changesSavedSuccessfully"
                @refreshEnd="onRefreshEnd"
            >
            </ai-tree-list-edit>
        </div>
        <div class='h-full flex flex-col w-full'>
            <div class="tep-header_block">
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Наименование</div>
                    <div style="width: 660px">
                        <ai-text-box
                            :value='nameTree'
                            @input='(data) => onTreeDataChange("name", data.newText)'
                        ></ai-text-box>
                    </div>
                </div>
                <div  class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Краткое наименование</div>
                        <div  style="width: 200px">
                            <ai-text-box
                                :value='nameShortTree'
                                @input='(data) => onTreeDataChange("name2", data.newText)'
                            ></ai-text-box>
                        </div>
                    </div>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Система нагрузки</div>
                        <div  class="tep-header-input" style="width: 300px">
                            <tep-lookup
                                :value='tiptnTree'
                                :meta='selectMeta'
                                :data-source='lookupTiptn'
                                @selected-value='(value) => onTreeDataChange("kod_tiptn", value)'
                            ></tep-lookup>
                        </div>
                    </div>
                </div>
            </div>
            <div class='text-xl tep-grid-name'>Удельные тепловые характеристики</div>
            <ai-grid-edit
                ref='gridRef'
                :meta='gridMeta'
                :args='gridArgs'
                :to-remove-toolbar-items-names='removeGridToolbarBtns'
            ></ai-grid-edit>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ds-tip-prib-view',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import AiTextBox from '@/components/ai-text-box.vue';
import TepLookup from '@/views/tep/tep-nsi/components/tep-lookup.vue';
import tepService from '@/service/tep-service';
import { getCookie } from '@/utils/cookies';

const treeRef = ref(null);
const dataTree = ref(null);
const btnToolbar = ref(null);
const gridRef = ref(null);
const gridArgs = ref();
const selectedNsiKod = ref(null);
const defaultSaveArgs = ref({kod_tipprn: -1, depId: +getCookie('dep')});
const nameTree = ref(null);
const nameShortTree = ref(null);
const tiptnTree = ref(null);
const lookupTiptn = ref(null);

onMounted(async() => {
    await treeRef.value?.setDataSource();
    await onStartSelectTree();
    lookupTiptn.value = await  tepService.getLookupsQkSxpris('tep-nsi./tep-nsi/lookup-ds-uvw-tiptn/select/get', {});
});

const onStartSelectTree = async(keySelect = null) => {
    let keySelectTreeFocus = keySelect;
    dataTree.value = await treeRef.value?.getTreeListDataSource();
    if(!keySelectTreeFocus) {
        keySelectTreeFocus = dataTree.value?.length ? dataTree.value[0].kod_tipprn : null;
    }
    selectedNsiKod.value = keySelectTreeFocus;
    await treeRef.value?.treeListInstance.option('focusedRowKey', keySelectTreeFocus);
    defaultSaveArgs.value.kod_tipprn = keySelectTreeFocus;
    await getGridArgs(keySelectTreeFocus);
    await getNameFields();

};

const getGridArgs = async (key) => {
    defaultSaveArgs.value.kod_tipprn = key;
    const defaultGridArgs = {
        select: {
            select_args: { ...defaultSaveArgs.value },
        },
        save: {
            update_args: { ...defaultSaveArgs.value },
            insert_args: { ...defaultSaveArgs.value },
            delete_args: { ...defaultSaveArgs.value },
        },
    };
    gridArgs.value = { ...defaultGridArgs };
    await  setTimeout(async () =>{
        await gridRef.value?.setDataSource();
        const dataGrid = await gridRef.value?.getGridDataSource();
        const keySelectGridFocus = dataGrid?.length ? dataGrid[0].kod : null;
        await gridRef.value?.gridInstance.option('focusedRowKey', keySelectGridFocus);
    }, 100);
};

const getNameFields = async () => {
    nameTree.value = await treeValue('name');
    nameShortTree.value = await treeValue('name2');
    tiptnTree.value = await treeValue('kod_tiptn');
};

const clearNameFields = () => {
    nameTree.value = null;
    nameShortTree.value = null;
}

const treeValue =  (field) => {
    const rowData = dataTree.value?.find(el => el.kod_tipprn === selectedNsiKod.value);
    return rowData ? rowData[field] : null
};

const onTreeCellClick = async (event, newEl = false) => {
    const check = await checkGrid();
    if(!check) return;
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    if( !buttonsRefs.value['isSaveButtonDisabled'] && !newEl && selectedNsiKod.value !== event.key) {
        const checkT = await checkTree();
        if(!checkT) return;
    }

    selectedNsiKod.value = event.key;
    await getNameFields();
    await buttonsStateChangeDisabled(false)

    if(selectedNsiKod.value !== defaultSaveArgs.value.kod_tipprn) {
        await getGridArgs(selectedNsiKod.value);
    }
};

const checkGrid = async () => {
    await gridRef.value.gridInstance.clearSelection();
    const canClose = await gridRef.value?.checkBeforeClose();
    return canClose;
};

const onToolbarClickTree = async(event) => {
    const name = event?.item?.component?.name;
    btnToolbar.value = name;
    const check = await checkGrid();
    if(!check) return;
};


const changesSavedSuccessfully = async() => {
    if(btnToolbar.value === 'delete') {
        await onStartSelectTree();
    }
    btnToolbar.value = null;
}

const checkTree = async () => {
    await treeRef.value.treeListInstance.clearSelection();
    let canClose = await treeRef.value?.checkBeforeClose();
    return canClose;
};

const onTreeDataChange = async (field, textData) => {
    if(field === 'kod_tiptn') tiptnTree.value = textData;
    const instance = await treeRef.value?.treeListInstance;
    if (!instance) return;
    const focusedRowKey = await instance.option('focusedRowKey');
    if (focusedRowKey != null) {
        const focusedRowIndex = instance.getRowIndexByKey(focusedRowKey);
        instance.cellValue(focusedRowIndex, field, textData);
        await buttonsStateChangeDisabled(true)
    }
};

const insertSave = async (insert) => {
    if(insert?.responses?.length) {
        await buttonsStateChangeDisabled(false);
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        if(insert?.responses[0].id) {
            selectedNsiKod.value = insert?.responses[0].id;
            await onStartSelectTree(selectedNsiKod.value);
        }
    }
};

const onUserDataChanged = async (userData) => {
    const insertData = userData.treeListChanges?.filter(el => el.type === 'insert') ?? [];
    if(insertData?.length) {
        const itemNew = insertData[0];
        await onTreeCellClick(itemNew, true);
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        await treeRef.value?.treeListInstance.option('focusedRowKey', itemNew.key);
    }
};

const buttonsStateChangeDisabled = async (status) => {
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    buttonsRefs.value['isAddChildButtonDisabled'] = status;
    buttonsRefs.value['isAddSiblingButtonDisabled'] = status;
    buttonsRefs.value['isDeleteButtonDisabled'] = status;
};

const onRefreshEnd = async () => {
    if(btnToolbar.value === 'refresh') {
        clearNameFields();
        await treeRef.value?.setFocusdRow(selectedNsiKod.value);
        await onStartSelectTree(selectedNsiKod.value);
    }
}

const removeTreeToolbarBtns = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser', 'cut', 'put'];

const removeGridToolbarBtns = ['choice', 'edit', 'show-column-chooser', 'searchPanel', 'copy'];

const treeMeta = {
    "keyExpr": "kod_tipprn",
    "columns": [
        {
            "name": "kod_tipprn",
            "caption": "kod_tipprn",
            "dataField": "kod_tipprn",
            "allowEditing": false,
            "width": 250,
            "index": 1,
            "visible": false
        },
        {
            "name": "name",
            "caption": "Наименование",
            "dataField": "name",
            "allowEditing": false,
            "width": '100%',
            "index": 2,
            "visible": true
        },
        {
            "name": "name2",
            "caption": "Краткое наименование",
            "dataField": "name2",
            "allowEditing": false,
            "width": 250,
            "index": 3,
            "visible": false
        },
        {
            "name": "kod_r",
            "caption": "kod_r",
            "dataField": "kod_r",
            "allowEditing": false,
            "width": 250,
            "index": 4,
            "visible": false
        },
        {
            "name": "kod_tiptn",
            "caption": "kod_tiptn",
            "dataField": "kod_tiptn",
            "allowEditing": false,
            "width": 250,
            "index": 5,
            "visible": false
        },
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/ds-tip-prib-tree/select/get",
        "save": "tep-nsi./tep-nsi/ds-tip-prib-tree/save/set"
    },
    "viewId": "  view-ds-tip-prib-tree",
    "parentIdExpr": "kod_r",
    'findTool': 'filter',
    'selectButtonMode': 'single',
    'selectionMode': 'single',
    'maxWidth': 'w-full',
    'wordWrapEnabled': true,
    'allowColumnResizing': false,
};

const selectMeta = {
    title: '',
    keyExpr: 'kod_tiptn',
    api: {select: 'tep-nsi./tep-nsi/lookup-ds-uvw-tiptn/select/get'},
    wordWrapEnabled: true,
    fieldNameText: "name",
    fieldNameId: "kod_tiptn",
    hasntRoute: true,
    columns: [
        {
            caption: '',
            name: 'kod_tiptn',
            dataField: 'kod_tiptn',
            visible: false,
            width: 50,
            index: 1,
        },
        {
            caption: '',
            name: 'name',
            dataField: 'name',
            visible: true,
            index: 2,
            allowFiltering: false
        },
    ],
    viewId: " lookup-ds-uvw-tiptn"
};

const gridMeta =  {
    'keyExpr': 'kod_uvw',
    'columns': [
        {
            'name': 'kod_uvw',
            'caption': 'kod_uvw',
            'dataField': 'kod_uvw',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'kod_tipprn',
            'caption': 'kod_tipprn',
            'dataField': 'kod_tipprn',
            'allowEditing': false,
            'width': 250,
            'index': 2,
            'visible': false,
        },
        {
            'name': 'tt',
            'caption': 'Разность температур (С)',
            'dataField': 'tt',
            'allowEditing': true,
            'dataType': 'number',
            'width': '50%',
            'index': 4,
            'visible': true,
        },
        {
            'name': 'qq',
            'caption': 'Удельный объем (м.куб./Гкал/час)',
            'dataField': 'qq',
            'allowEditing': true,
            'dataType': 'number',
            'width': '50%',
            'index': 5,
            'visible': true,
        },

    ],
    'api': {
        'select': 'tep-nsi./tep-nsi/ds-tip-prib-grid/select/get',
        'save': 'tep-nsi./tep-nsi/ds-tip-prib-grid/save/set',
    },
    'viewId': 'view-ds-tip-prib-grid',
    isFilterPanelVisible: false,
};
</script>
<style scoped>
.tep-tree__container {
    flex: 0 0 500px;
}
.tep-grid-name {
    width: 100%;
    text-align: center;
    padding: 10px 0;
}
.tep-header-item {
    align-items: center;
    gap: 4px;
}
.tep-header-label {
    width: 155px;
    text-align: right;
}
.tep-header_block {
    margin: 0 0 20px;
    padding: 0 0 20px;
    border-bottom: 1px solid  rgba(191, 191, 191, .7);;
}
:root .tep-header-input :deep(.dx-field-value) {
    width: 100%;
}
</style>
